import { Button, ButtonProps, styled } from '@mui/material';
import { ReactNode } from 'react';

export type EditorToolbarButtonSize = 'small' | 'medium';

const StyledButton = styled(Button, {
  name: 'StyledButton',
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'buttonSize',
})<{
  isActive: boolean;
  buttonSize: EditorToolbarButtonSize;
}>(({ theme, isActive, buttonSize }) => ({
  padding: theme.spacing(0.5),
  minWidth: '1rem',
  color: 'inherit',
  backgroundColor: isActive ? theme.palette.custom.OV.sys.tertiaryContainer : 'none',

  '&:active, &:hover': {
    backgroundColor: theme.palette.custom.OV.sys.tertiaryContainer,
  },

  ...(buttonSize === 'small' && {
    width: '1.75rem',
    height: '1.75rem',
    minWidth: '1.75rem',
    padding: 0,
    borderRadius: '0.375rem',
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
    backgroundColor: isActive ? theme.palette.custom.OV.sys.tertiaryContainer : 'transparent',
    '& svg, & .MuiSvgIcon-root': {
      fontSize: '1rem',
    },
    '&:active, &:hover': {
      backgroundColor: isActive
        ? theme.palette.custom.OV.sys.tertiaryContainer
        : theme.palette.custom.OV.sys.surfaceContainer,
      color: theme.palette.custom.OV.sys.onBackground,
    },
  }),
}));

type EditorToolbarButtonProps = {
  children: ReactNode;
  isActive?: boolean;
  size?: EditorToolbarButtonSize;
} & Omit<ButtonProps, 'size'>;

export const EditorToolbarButton = ({
  children,
  isActive = false,
  size = 'medium',
  ...rest
}: EditorToolbarButtonProps) => {
  return (
    <StyledButton
      isActive={isActive}
      buttonSize={size}
      variant={isActive ? 'contained' : 'text'}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};
